import {
  EnqueueSnackbarType,
  showMessage,
} from './../components/common/Helpers'
import {
  CabinetProps,
  CabinetType,
  DoorType,
  DoorVisualType,
  LegPropsType,
  CornerCabinetProps,
} from './../redux/cabinetReducer'
import { FocusEvent, KeyboardEvent } from 'react'
import { GridStateType, RoleType } from '../redux/appReducer'
import { ItemPropsType } from '../classes/Item'
import crypto from 'crypto-js'

type SearchObjectResultType = { path: string; value: Object }

export const searchObject = (
  object: Object,
  matchCallback: (obj: Object) => boolean,
  currentPath?: string,
  result?: SearchObjectResultType[],
  searched?: Object[]
): Array<SearchObjectResultType> => {
  currentPath = currentPath || ''
  result = result || []
  searched = searched || []
  if (searched.indexOf(object) !== -1 && object === Object(object)) {
    return []
  }
  searched.push(object)
  if (matchCallback(object)) {
    result.push({ path: currentPath, value: object })
  }
  try {
    if (object === Object(object)) {
      for (var property in object) {
        if (property.indexOf('$') !== 0) {
          //if (Object.prototype.hasOwnProperty.call(object, property)) {
          // @ts-ignore
          searchObject(
            object[property],
            matchCallback,
            currentPath + '.' + property,
            result,
            searched
          )
          //}
        }
      }
    }
  } catch (e) {
    console.log(object)
    throw e
  }
  return result
}

export const handleFocus = (event: FocusEvent) => {
  ;(<HTMLInputElement>event.target).select()
}

export const handleEnter = (
  event: KeyboardEvent,
  handleBlurCallback: () => void
  // value: number
) => {
  if (event.key === 'Enter') {
    handleBlurCallback()
    // (<HTMLInputElement>event.target).blur()
  }
}

export const saveCabinetPropsInLocalStorage = (
  props: CabinetProps,
  doorType: DoorType,
  doorVisualType: DoorVisualType,
  legProps: LegPropsType,
  splittedTop: boolean,
  cabinetType: CabinetType
) => {
  if (props) localStorage.setItem('cabinetProps', JSON.stringify(props))
  if (doorType) localStorage.setItem('doorType', doorType)
  if (doorVisualType) localStorage.setItem('doorVisualType', doorVisualType)
  if (legProps) localStorage.setItem('legProps', JSON.stringify(legProps))
  if (splittedTop !== undefined)
    localStorage.setItem('splittedTop', JSON.stringify(splittedTop))
  if (cabinetType) localStorage.setItem('cabinetType', cabinetType)
}

export const saveCornerCabinetPropsInLocalStorage = (
  props: CornerCabinetProps,
  doorType: DoorType,
  doorVisualType: DoorVisualType,
  legProps: LegPropsType,
  splittedTop: boolean,
  cabinetType: CabinetType
) => {
  if (props) localStorage.setItem('cornerCabinetProps', JSON.stringify(props))
  if (doorType) localStorage.setItem('doorType', doorType)
  if (doorVisualType) localStorage.setItem('doorVisualType', doorVisualType)
  if (legProps) localStorage.setItem('legProps', JSON.stringify(legProps))
  if (splittedTop !== undefined)
    localStorage.setItem('splittedTop', JSON.stringify(splittedTop))
  if (cabinetType) localStorage.setItem('cabinetType', cabinetType)
}

export const saveGridStateInLocalStorage = (
  state: GridStateType,
  of:
    | 'hardware'
    | 'material'
    | 'materialGroup'
    | 'usersInfo'
    | 'userCabinets'
    | 'category'
    | 'costumer'
    | 'floorMaterial'
) => {
  localStorage.setItem(of + 'GridState', JSON.stringify(state))
}

export const saveItemsPropsListInLocalStorage = (
  itemsProps: ItemPropsType[]
) => {
  localStorage.setItem('itemsProps', JSON.stringify(itemsProps))
}

export const isEmail = (text: string) => {
  // eslint-disable-next-line no-useless-escape
  const emailReg =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return emailReg.test(text)
}

export const saveImage = (blob: Blob, filename: string) => {
  let link = document.createElement('a')
  link.style.display = 'none'
  document.body.appendChild(link)
  link.href = URL.createObjectURL(blob)
  link.download = filename
  link.click()
}

function fallbackCopyTextToClipboard(
  text: string,
  enqueueSnackbar?: EnqueueSnackbarType
) {
  var textArea = document.createElement('textarea')
  textArea.value = text

  // Avoid scrolling to bottom
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    document.execCommand('copy')
    if (enqueueSnackbar) showMessage(enqueueSnackbar, 'Link Copied', 'success')
  } catch (err) {
    if (enqueueSnackbar)
      showMessage(
        enqueueSnackbar,
        'Something went wrong, please copy link manually'
      )
    else console.error('cant copy')
  }

  document.body.removeChild(textArea)
}

export function copyTextToClipboard(
  text: string,
  enqueueSnackbar?: EnqueueSnackbarType,
  successMessage?: string
) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text, enqueueSnackbar)
    return
  }
  navigator.clipboard.writeText(text).then(
    function () {
      if (enqueueSnackbar)
        showMessage(enqueueSnackbar, successMessage || 'Link Copied', 'success')
    },
    function (err) {
      if (enqueueSnackbar)
        showMessage(
          enqueueSnackbar,
          'Something went wrong, please copy manually'
        )
      else console.error('cant copy')
    }
  )
}

export const encryptAES = (text: string) => {
  return crypto.AES.encrypt(text, process.env.REACT_APP_AES_KEY || 'key')
    .toString()
    .replaceAll('/', '*')
    .replaceAll('+', '~')
}

export const decryptAES = (text: string) => {
  return crypto.AES.decrypt(
    text.replaceAll('*', '/').replaceAll('~', '+'),
    process.env.REACT_APP_AES_KEY || 'key'
  ).toString(crypto.enc.Utf8)
}

export const getCabinetPropFromName = (name: string, prop: string) => {
  // 0|t|150;191;60.4|t25.95;t126.91;f147.00;f167.10|d_2_c|3;4;5|2_3|2|0_0|1|12
  // 2|b|60;100;80;60;60;40;40|f17.785||||0;0|0_0|2|12|-10_-25
  const splittedN = name.split('|')

  if (prop === 'type') {
    const type = splittedN[1]
    return type === 'b'
      ? 'base'
      : type === 't'
      ? 'tall'
      : type === 'u'
      ? 'upper'
      : 'unknown'
  } else if (prop === 'width') {
    return splittedN[2].split(';')[name[0] === '0' ? 0 : 1]
  } else if (prop === 'height') {
    return splittedN[2].split(';')[name[0] === '0' ? 1 : 0]
  } else if (prop === 'depth') {
    return splittedN[2].split(';')[name[0] === '0' ? 2 : 3]
  } else if (prop === 'backWidth') {
    return name[0] === '0' ? '' : splittedN[2].split(';')[5]
  } else if (prop === 'sectionsCount') {
    return splittedN[3].split(';').length + 1
  } else if (prop === 'doorsCount') {
    return splittedN[4].split(';').length
  } else if (prop === 'drawersCount') {
    return splittedN[5].split(';').length
  } else if (prop === 'cornerType') {
    return name[0] === '0' ? '' : name[0] === '1' ? 'angled' : '2 door'
  }
}

export const resizeBase64Img = (
  base64: string,
  newWidth: number,
  newHeight: number
) => {
  return new Promise<string>((resolve, reject) => {
    var canvas = document.createElement('canvas')
    // canvas.style.width = newWidth.toString() + "px";
    // canvas.style.height = newHeight.toString() + "px";
    let context = canvas.getContext('2d')
    let img = document.createElement('img')
    img.src = base64
    img.onload = function () {
      if (context) {
        // context.scale(newWidth / img.width, newHeight / img.height);
        canvas.width = newWidth
        canvas.height = newHeight
        context.drawImage(img, 0, 0, newWidth, newHeight)
        resolve(canvas.toDataURL())
      } else reject('context is not available')
    }
  })
}

export const USStates = [
  { name: 'Alabama', abbreviation: 'AL' },
  { name: 'Alaska', abbreviation: 'AK' },
  { name: 'Arizona', abbreviation: 'AZ' },
  { name: 'Arkansas', abbreviation: 'AR' },
  { name: 'California', abbreviation: 'CA' },
  { name: 'Colorado', abbreviation: 'CO' },
  { name: 'Connecticut', abbreviation: 'CT' },
  { name: 'Delaware', abbreviation: 'DE' },
  { name: 'Florida', abbreviation: 'FL' },
  { name: 'Georgia', abbreviation: 'GA' },
  { name: 'Hawaii', abbreviation: 'HI' },
  { name: 'Idaho', abbreviation: 'ID' },
  { name: 'Illinois', abbreviation: 'IL' },
  { name: 'Indiana', abbreviation: 'IN' },
  { name: 'Iowa', abbreviation: 'IA' },
  { name: 'Kansas', abbreviation: 'KS' },
  { name: 'Kentucky', abbreviation: 'KY' },
  { name: 'Louisiana', abbreviation: 'LA' },
  { name: 'Maine', abbreviation: 'ME' },
  { name: 'Maryland', abbreviation: 'MD' },
  { name: 'Massachusetts', abbreviation: 'MA' },
  { name: 'Michigan', abbreviation: 'MI' },
  { name: 'Minnesota', abbreviation: 'MN' },
  { name: 'Mississippi', abbreviation: 'MS' },
  { name: 'Missouri', abbreviation: 'MO' },
  { name: 'Montana', abbreviation: 'MT' },
  { name: 'Nebraska', abbreviation: 'NE' },
  { name: 'Nevada', abbreviation: 'NV' },
  { name: 'New Hampshire', abbreviation: 'NH' },
  { name: 'New Jersey', abbreviation: 'NJ' },
  { name: 'New Mexico', abbreviation: 'NM' },
  { name: 'New York', abbreviation: 'NY' },
  { name: 'North Carolina', abbreviation: 'NC' },
  { name: 'North Dakota', abbreviation: 'ND' },
  { name: 'Ohio', abbreviation: 'OH' },
  { name: 'Oklahoma', abbreviation: 'OK' },
  { name: 'Oregon', abbreviation: 'OR' },
  { name: 'Pennsylvania', abbreviation: 'PA' },
  { name: 'Rhode Island', abbreviation: 'RI' },
  { name: 'South Carolina', abbreviation: 'SC' },
  { name: 'South Dakota', abbreviation: 'SD' },
  { name: 'Tennessee', abbreviation: 'TN' },
  { name: 'Texas', abbreviation: 'TX' },
  { name: 'Utah', abbreviation: 'UT' },
  { name: 'Vermont', abbreviation: 'VT' },
  { name: 'Virginia', abbreviation: 'VA' },
  { name: 'Washington', abbreviation: 'WA' },
  { name: 'West Virginia', abbreviation: 'WV' },
  { name: 'Wisconsin', abbreviation: 'WI' },
  { name: 'Wyoming', abbreviation: 'WY' },
]

export const setCharAt = (str: string, index: number, chr: string) => {
  if (index > str.length - 1) return str
  return str.substring(0, index) + chr + str.substring(index + 1)
}

export const getRoleIndex = (role: RoleType) => {
  //how to determine ratail or delaer end user
  if (role) {
    switch (role) {
      case 'company':
        return 0
      case 'engineer':
        return 1
      case 'designer':
        return 4
      case 'designer2':
        return 5
      default:
        return 3 //isGC? 2 :3
    }
  } else {
    return 3 //isGC? 2 :3
  }
}

const componentToHex = (c: number) => {
  const hex = c.toString(16)
  return hex.length == 1 ? '0' + hex : hex
}

export const rgbToHex = (r: number, g: number, b: number) => {
  return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b)
}
